module.exports = __webpack_public_path__ + "static/media/Veg.ad2ca648.png";